import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/whatsapp`;
const opts = { withCredentials: true };

export async function fetchWaMetricsToday() {
  const { data } = await axios.get(`${API}/metrics/today`, opts);
  return data;
}

export async function fetchWaActiveSessions() {
  const { data } = await axios.get(`${API}/sessions/active`, opts);
  return data;
}

export async function fetchWaFunnel() {
  const { data } = await axios.get(`${API}/metrics/funnel`, opts);
  return data;
}

export async function fetchWaAbandoned() {
  const { data } = await axios.get(`${API}/sessions/abandoned`, opts);
  return data;
}

export async function fetchWaLogs(params = {}) {
  const { data } = await axios.get(`${API}/logs`, { ...opts, params });
  return data;
}

export async function fetchWaAgents() {
  const { data } = await axios.get(`${API}/agents`, opts);
  return data;
}

export async function createWaAgent(body) {
  const { data } = await axios.post(`${API}/agents`, body, opts);
  return data;
}

export async function patchWaAgent(id, isActive) {
  const { data } = await axios.patch(`${API}/agents/${id}`, null, { ...opts, params: { is_active: isActive } });
  return data;
}

export async function deleteWaAgent(id) {
  const { data } = await axios.delete(`${API}/agents/${id}`, opts);
  return data;
}

export async function forceHandoff(sessionId) {
  const { data } = await axios.post(`${API}/sessions/${sessionId}/handoff`, {}, opts);
  return data;
}

export async function fetchWaBlocklist() {
  const { data } = await axios.get(`${API}/blocklist`, opts);
  return data;
}

export async function addWaBlock(phone, reason) {
  const { data } = await axios.post(`${API}/blocklist`, { phone, reason }, opts);
  return data;
}

export async function removeWaBlock(entryId) {
  const { data } = await axios.delete(`${API}/blocklist/${entryId}`, opts);
  return data;
}

export async function fetchWaSession(sessionId) {
  const { data } = await axios.get(`${API}/sessions/${sessionId}`, opts);
  return data;
}

export async function fetchWaTranscript(sessionId) {
  const { data } = await axios.get(`${API}/sessions/${sessionId}/transcript`, opts);
  return data;
}

export async function fetchWaHealth() {
  const { data } = await axios.get(`${API}/health/bot`, opts);
  return data;
}

export async function fetchWaConversion(params = {}) {
  const { data } = await axios.get(`${API}/metrics/conversion`, { ...opts, params });
  return data;
}

export async function fetchWaHourly(days = 7) {
  const { data } = await axios.get(`${API}/metrics/hourly`, { ...opts, params: { days } });
  return data;
}

export async function fetchWaBookings(limit = 20) {
  const { data } = await axios.get(`${API}/bookings`, { ...opts, params: { limit } });
  return data;
}

export async function simulateWaMessage(body) {
  const { data } = await axios.post(`${API}/simulate/message`, body, opts);
  return data;
}

export async function simulateWaReset(phone) {
  const { data } = await axios.post(`${API}/simulate/reset`, { phone }, opts);
  return data;
}

export async function fetchSimulateSession(phone) {
  const { data } = await axios.get(`${API}/simulate/session`, { ...opts, params: { phone } });
  return data;
}

export function waLogsExportUrl() {
  return `${API}/logs/export`;
}

export function opsMonitorUrl(bookingId) {
  if (!bookingId) return '/admin/ops-monitor';
  return `/admin/ops-monitor?focus=${encodeURIComponent(bookingId)}`;
}
